// eslint-disable-next-line no-shadow
export enum GenderEnum {
  Male = 'M',
  Female = 'F',
  Other = 'O',
  NoAnswer = 'N/A',
}
